import koalition from '../../../api/koalition'
import useFormBuilder from '../../../hooks/FormBuilderHook'
import Input from '../../forms/Input/Input'
import Validators from '../../../forms/Validators'
import { useModal } from '../../../contexts/Modal'
import { useEffect, useRef, useState } from 'react'
import { useToaster } from '../../../contexts/Toaster'
import { useCharacters } from '../../../contexts/Characters'
import { capitalize } from '../../../utilities/helpers'
import { unitTypes } from '../../../utilities/constants'

const EditMercenaryTech = ({}) => {
    const modal = useModal()
    const toaster = useToaster()
    const characters = useCharacters()
    const formName = 'editMercenaryTech'
    const { character } = modal.$state.data

    const editMercenaryTechRef = useRef()
    editMercenaryTechRef.current = () => {
        const formValues = form.$state.value

        koalition.put(`characters/${character._id}`, formValues).then((response) => {
            modal.close()
            toaster.success('Mercenary tech updated successfully')
        }).catch((error) => {
            toaster.error(error)
            console.error(error)
        })
    }

    const mercenaryTech1Controls = Object.fromEntries(Object.entries(character.mercenaryTech1).map(([unitType, progress]) => [
        unitType,
        { validators: [Validators.integer, Validators.min(0), Validators.max(100)], value: progress }
    ]))
    const mercenaryTech2Controls = Object.fromEntries(Object.entries(character.mercenaryTech2).map(([unitType, progress]) => [
        unitType,
        { validators: [Validators.integer, Validators.min(0), Validators.max(100)], value: progress }
    ]))
    const form = useFormBuilder({ formName, onSubmit: () => editMercenaryTechRef.current(), controls: {
        mercenaryTech1: { type: 'group', controls: mercenaryTech1Controls },
        mercenaryTech2: { type: 'group', controls: mercenaryTech2Controls }
    } })

    useEffect(() => {
        modal.configure({ formName, submitLabel: 'Save' })
    }, [])

    return (
        <div className="row justify-content-center">
            {form.$state && Object.entries(form.$state.controls).map(([stageName, stageFormGroup], index) => (
                <div className="col-sm-6 mb-3" key={stageName}>
                    <div className="card dark">
                        <h3 className="text-center mb-4">Stage {index + 1}</h3>
                        {unitTypes.map((unitType) => (
                            <div className="mb-3" key={unitType}>
                                <Input type="number" control={stageFormGroup.controls[unitType]} label={capitalize(unitType)} />
                            </div>
                        ))}
                    </div>
                </div>
            ))}
        </div>
    )
}

export default EditMercenaryTech